type Props = {
  dayOfMonth: number;
  date?: Date | undefined;
};

const DatePickerCustomDay = ({ dayOfMonth }: Props) => {
  return <span className="react-datepicker__day_span">{dayOfMonth}</span>;
};

export default DatePickerCustomDay;
